export default __webpack_public_path__ + "static/media/scotia-bank-logo.481862bf.svg";